import React from "react";
import { useHistory } from "react-router-dom";
import AuthManager from "../../Common/AuthManager";
import AppSettings from "../../Settings/AppSettings";
import Label from "../../Components/Common/components/Label";

function LandingDashboard(props) {
  const history = useHistory();

  const get_username = () => {
    let userObj = null;

    if (AuthManager.isAuthenticated()) userObj = AuthManager.getAuthUser();
    if (
      userObj === null ||
      userObj === undefined ||
      userObj.profile === null ||
      userObj.profile === undefined
    )
      return "guest";

    return userObj.profile.first_name;
    // return userObj.profile.first_name + ' ' + userObj.profile.last_name;
  };

  function Open_dbpromoter_app() {
    let app_url =
      AppSettings.DBPROMOTER_APP_URL +
      "callback/login?t=" +
      AuthManager.getSamsToken();
    window.open(app_url, "_blank");
  }

  React.useEffect(() => {}, []);

  return (
    <React.Fragment>
      <div className="container col-8 h-100 justify-content-center align-items-center ">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        <div className="row">
          <Label
            message={`Welcome, ${get_username()}`}
            fontSize={1.8}
            fontWeight="700"
          />
          <Label
            message="What would you like to do today?"
            fontSize={1.8}
            fontWeight="700"
          />
          <hr />
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className="mb-3 card border-dark">
              <div className="card-body text-dark">
                <Label message="GMS" fontSize={1.2} fontWeight="700" />
                <Label
                  message="Some quick example text to build on the card title and make up
                  the bulk of the card's content."
                  fontSize={0.9}
                  fontWeight="500"
                />
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => history.replace("/workspace/preparing")}
                >
                  Take me to GMS
                </button>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="mb-3 card border-dark">
              <div className="card-body text-dark">
                <Label
                  message="GMS Administration"
                  fontSize={1.2}
                  fontWeight="700"
                />
                <Label
                  message="Some quick example text to build on the card title and make up
                  the bulk of the card's content."
                  fontSize={0.9}
                  fontWeight="500"
                />
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => history.replace("/admin/dashboard")}
                >
                  Take me to Admin side
                </button>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="mb-3 card border-dark">
              <div className="card-body text-dark">
                <Label message="DB Promoter" fontSize={1.2} fontWeight="700" />
                <Label
                  message="Some quick example text to build on the card title and make up
                  the bulk of the card's content."
                  fontSize={0.9}
                  fontWeight="500"
                />
                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => Open_dbpromoter_app()}
                >
                  Take me there
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default LandingDashboard;
